export type ProjectStatus = "planning" | "in_progress" | "on_hold" | "complete";

export interface Project {
  id: string;
  contractor_id: string;
  client_id: string | null;
  title: string;
  address: string | null;
  status: ProjectStatus;
  start_date: string | null;
  estimated_completion_date: string | null;
  budget: number | null;
  // Populated when a client deletes their account — preserved as a paper trail
  client_name_snap: string | null;
  client_email_snap: string | null;
  created_at: string;
  updated_at: string;
}

export interface UserSummary {
  id: string;
  email: string;
  name: string | null;
}

export interface ProjectFormData {
  title: string;
  address: string;
  clientEmail: string;
  status: ProjectStatus;
  startDate: string;
  estimatedCompletionDate: string;
  budget: string;
}

export const statusOptions: { value: ProjectStatus; label: string }[] = [
  { value: "planning", label: "Planning" },
  { value: "in_progress", label: "In Progress" },
  { value: "on_hold", label: "On Hold" },
  { value: "complete", label: "Complete" },
];
